export var OrgAccessLevel;
(function (OrgAccessLevel) {
    OrgAccessLevel[OrgAccessLevel["noAccess"] = 0] = "noAccess";
    OrgAccessLevel[OrgAccessLevel["read"] = 1] = "read";
    OrgAccessLevel[OrgAccessLevel["write"] = 2] = "write";
})(OrgAccessLevel || (OrgAccessLevel = {}));
//# sourceMappingURL=types.js.map